import React, { useEffect, useState } from 'react';
import BsModal from '../Common/BsModal';
import TextInput from '../Common/TextInput';
import Notification from '../Common/Notification';
import ajaxGym from '../../util/remote/ajaxGym';
import { useGym } from '../../DataStore/Gym/GymContext';
import ActivityLoader from '../Common/ActivityLoader';

const ScheduleClassModal = ({ show, onClose, onClassScheduled }) => {
  const [gymClass, setGymClass] = useState('');
  const [dayOfWeek, setDayOfWeek] = useState('');
  const [time, setTime] = useState('');
  const [duration, setDuration] = useState('30');
  const [participants, setParticipants] = useState('10');
  const [loading, setLoading] = useState(false);
  const [notify, setNotify] = useState(null);
  const {  getGymClasses, gymClasses, getScheduledClasses} = useGym();

  useEffect(() => {
    getGymClasses();
  }, []);
  

  const handleSchedule = async () => {
    if (!gymClass || !dayOfWeek || !time) {
      setNotify(<Notification type='danger' message='Complete all field, they try again.' />);
      return;
    }

    setLoading(true);
    const server_response = await ajaxGym.scheduleClass({
      class_id: gymClass?.value,
      day_of_week: dayOfWeek?.value,
      scheduled_time: time,
      duration_minutes: duration,
      max_participants: participants
    });

    setLoading(false);

    if (server_response.status === "OK") {
      setNotify(<Notification type='success' message={server_response.message} />);
      setTime('');
      getScheduledClasses();
    } else {
      setNotify(<Notification type='danger' message={server_response.message} />);
    }
  };

  const closeModal = () => {
    setTime('');
    setDuration('30');
    setParticipants('10');
    setNotify(null);
    onClose();
  };

  const RenderClass = () => {
    const options = [];
    Array.isArray(gymClasses) &&
    gymClasses.map((item) =>
        options.push({ label: item.class_name, value: item.id })
      );

    return (
      <TextInput
        label="Gym Class"
        type="select"
        leftIcon="fa fa-dumbbell"
        placeholder={gymClass.label || "Select class...."}
        options={options}
        onChange={(item) => setGymClass(item)}
        leftComponent={
          <i className="fa fa-dumbbell link" onClick={getGymClasses}></i>
        }
        loading={!gymClasses}
      />
    );
  };


  const RenderWeekday = () => {
    const options = [
      { label: 'Monday', value: 1 },
      { label: 'Tuesday', value: 2 },
      { label: 'Wednesday', value: 3 },
      { label: 'Thursday', value: 4 },
      { label: 'Friday', value: 5 },
      { label: 'Saturday', value: 6 },
      { label: 'Sunday', value: 7 }
    ];

    return (
      <TextInput
        label="Weekday"
        type="select"
        leftIcon="fa fa-calendar-alt-day"
        placeholder={dayOfWeek.label || "Select weekday...."}
        options={options}
        onChange={(item) => setDayOfWeek(item)}
        leftComponent={
          <i className="fa fa-calendar-alt-day link"></i>
        }
      />
    );
  }

  return (
    <BsModal
      show={show}
      onClose={closeModal}
      title="Schedule Class Session"
      footer={
        <>
          <button type="button" className="btn btn-secondary" onClick={closeModal}>
            Cancel
          </button>
          <button
            className="btn btn-success"
            disabled={loading || !gymClass || !dayOfWeek || !time}
            onClick={handleSchedule}
          >
            <i className="fa fa-clock mr-1"></i> Schedule
          </button>
        </>
      }
    >
        {RenderClass()}
     
        {RenderWeekday()}
      <TextInput
        label="Time"
        type="time"
        placeholder="e.g. 10:00 am"
        leftIcon="fa fa-clock"
        value={time}
        onChange={e => setTime(e.target.value)}
        required
      />

     <TextInput
        label="Duration (minutes)"
        placeholder="30"
        leftIcon="fa fa-hourglass-half"
        value={duration}
        onChange={e => setDuration(e.target.value)}
      />
    
      <TextInput
        label="Max Participants"
        placeholder="10"
        leftIcon="fa fa-users"
        value={participants}
        onChange={e => setParticipants(e.target.value)}
      />

      {loading && <ActivityLoader />}
      {notify}
    </BsModal>
  );
};

export default ScheduleClassModal;
